import useSWR, { SWRResponse, SWRConfiguration } from 'swr';
import { AxiosError } from 'axios';
import { OfferAcceptance, Offer } from '../../../providers/api/dtos';
import { API_OFFERS_PATH } from '../../../providers/api/api';
import { getOfferAcceptance } from '../../../providers/api/offer/offerProvider';

export const OFFER_ACCEPTANCE_RID = `${API_OFFERS_PATH}/:id/acceptance`;

export default function useOfferAcceptance(
  offerId?: NonNullable<Offer['id']>,
  options?: SWRConfiguration<OfferAcceptance, AxiosError>,
): SWRResponse<OfferAcceptance, AxiosError> {
  const key = offerId ? [OFFER_ACCEPTANCE_RID, offerId] : null;

  return useSWR(key, () => getOfferAcceptance(offerId!), options);
}
